import c from 'classnames';
import { useNavigate } from 'react-router-dom';

import { TextColor, Typography } from '@repo/ui';

import { TextLink } from 'components';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';
import { ConditionMetricPill } from './ConditionMetricPill';

import styles from './ConditionMetricCard.module.css';

export const ConditionMetricCard = ({
  title,
  evaluationCounts,
  action_items,
  link,
  sensitive,
}: {
  title: string;
  evaluationCounts?: {
    great: number;
    okay: number;
    support: number;
    improve: number;
  };
  action_items?: number;
  link?: string;
  sensitive?: boolean;
}) => {
  const navigate = useNavigate();
  const { trackEvent } = useAnalytics();
  const navigateToLink = () => {
    if (!link) return;
    trackEvent('Condition Card Clicked', {
      condition_name: title,
      condition: link,
      experience: 'legacy_conditions',
    });
    navigate(link);
  };
  let action_item_text = action_items
    ? action_items + ` condition action${action_items === 1 ? '' : 's'}`
    : '';

  return (
    <div
      className={c(styles.card, !link && styles.noLink)}
      onClick={navigateToLink}
    >
      <div className={styles.content}>
        <Typography variant='heading-m'>{title}</Typography>
        <div className={styles.evaluationRow}>
          {!sensitive ? (
            !!evaluationCounts && (
              <div className='flex'>
                <ConditionMetricPill
                  good={evaluationCounts.great}
                  okay={evaluationCounts.okay}
                  improve={evaluationCounts.improve}
                  support={evaluationCounts.support}
                />
              </div>
            )
          ) : (
            <Typography variant='caption' color='warm-grey-700'>
              View details to see metrics
            </Typography>
          )}
        </div>
        <div className={styles.footerLinks}>
          <div className={styles.link}>
            <TextLink
              label={action_item_text}
              color={TextColor.PURPLE}
              contentOnly
            />
          </div>
          <div>
            <TextLink
              label='See details'
              iconNameRight='chevronForward'
              color={TextColor.PURPLE}
              contentOnly
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConditionMetricCard;
